import useGetDataProviders from "../../../hooks/media/useGetDataProviders";
import useGetDisplayMediaTypes from "../../../hooks/media/useGetDisplayMediaTypes";
import PropTypes from "prop-types";
import Grid from "@mui/material/Unstable_Grid2";
import {
  Box,
  Button,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  OutlinedInput,
  Typography,
  Checkbox,
  ListItemText,
} from "@mui/material/";
import { Search } from "@mui/icons-material/";
import { AllmappingsFiltersStrings } from "./locale";
import { initLocalization } from "../../../utils/helpers";
import { NumericInput } from "../../common/numericInput/NumericInput";

export const AllmappingsFilters = ({ filters, setFilters, onSearch }) => {
  initLocalization(AllmappingsFiltersStrings);

  const { dataProviders } = useGetDataProviders(true);
  const { displayMediaTypes } = useGetDisplayMediaTypes(true);

  const handleSetFilters = (event) => {
    setFilters((prev) => ({
      ...prev,
      [event.target.name]: event.target.value,
    }));
  };

  const handleFieldKeydown = (event) => {
    if (event.key === "Enter" && event.target.value) {
      event.stopPropagation();
      onSearch();
    }
  };

  return (
    <Grid container className="creative-review-filters">
      <Grid
        xs={12}
        display="flex"
        flexDirection={{ xs: "column", sm: "row" }}
        gap={2}
      >
        <Box sx={{ flex: "1" }}>
          <NumericInput
            label={AllmappingsFiltersStrings.mediaId}
            name="mediaId"
            value={filters.mediaId || ""}
            setValue={(val) =>
              setFilters((prev) => ({
                ...prev,
                mediaId: val,
              }))
            }
            size="small"
            fullWidth
          />
        </Box>

        <Box sx={{ flex: "1" }}>
          <TextField
            label={AllmappingsFiltersStrings.mediaLabel}
            size="small"
            name="mediaLabel"
            value={filters.mediaLabel || ""}
            onChange={handleSetFilters}
            onKeyDown={handleFieldKeydown}
            fullWidth
          />
        </Box>

        <Box sx={{ flex: "1" }}>
          <FormControl fullWidth size="small">
            <InputLabel id="data-provider-label">
              {AllmappingsFiltersStrings.DataProvider}
            </InputLabel>
            <Select
              labelId="data-provider-label"
              id="data-provider-select"
              multiple
              value={filters.media || []}
              onChange={handleSetFilters}
              input={
                <OutlinedInput label={AllmappingsFiltersStrings.DataProvider} />
              }
              name="media"
              renderValue={(selected) => (
                <Typography>{selected.join(", ")}</Typography>
              )}
            >
              {dataProviders.map((provider) => (
                <MenuItem key={provider.id} value={provider.name}>
                  <Checkbox checked={filters.media?.includes(provider.name)} />
                  <ListItemText primary={provider.name} />
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>

        <Box sx={{ flex: "1" }}>
          <FormControl fullWidth size="small">
            <InputLabel id="display-media-type-label">
              {AllmappingsFiltersStrings.DisplayMediaType}
            </InputLabel>
            <Select
              labelId="display-media-type-label"
              id="display-media-type-select"
              value={filters.displayMediaType || ""}
              onChange={handleSetFilters}
              input={
                <OutlinedInput
                  label={AllmappingsFiltersStrings.DisplayMediaType}
                />
              }
              name="displayMediaType"
            >
              {displayMediaTypes.map((type) => (
                <MenuItem key={type.id} value={type.name}>
                  {type.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
        <Box sx={{ flex: "1" }}>
          <NumericInput
            label={AllmappingsFiltersStrings.bisId}
            name="bisId"
            value={filters.bisId || ""}
            setValue={(val) =>
              setFilters((prev) => ({
                ...prev,
                bisId: val,
              }))
            }
            size="small"
            fullWidth
          />
        </Box>

        <Box sx={{ flex: "1" }}>
          <TextField
            label={AllmappingsFiltersStrings.bisLabel}
            size="small"
            name="bisLabel"
            value={filters.bisLabel || ""}
            onChange={handleSetFilters}
            onKeyDown={handleFieldKeydown}
            fullWidth
          />
        </Box>

        <Button
          startIcon={<Search />}
          variant="contained"
          color="secondary"
          onClick={onSearch}
        >
          {AllmappingsFiltersStrings.search}
        </Button>
      </Grid>
    </Grid>
  );
};

AllmappingsFilters.propTypes = {
  filters: PropTypes.shape({
    mediaId: PropTypes.string,
    mediaLabel: PropTypes.string,
    media: PropTypes.array,
    bisId: PropTypes.string,
    bisLabel: PropTypes.string,
    displayMediaType: PropTypes.string,
  }).isRequired,
  setFilters: PropTypes.func.isRequired,
  onSearch: PropTypes.func.isRequired,
};
